import React from 'react'

import { getHotlinePhone } from 'shared/utils'

export type BlockType = {
  type: 'paragraph' | 'list' | 'title'
  content: string | (string | JSX.Element)[]
}

export const principles: BlockType[] = [
  {
    type: 'paragraph',
    content:
      'Кодекс устанавливает основные принципы поведения и принятия решений, но невозможно предвидеть каждую ситуацию, которая может возникнуть.',
  },
  {
    type: 'paragraph',
    content:
      'Если вы не знаете, как поступить, задайте себе следующие вопросы:',
  },
  {
    type: 'list',
    content: [
      'Это законно?',
      'Это честно и справедливо?',
      'Отвечает ли это интересам МТС Медиа?',
      'Согласуется ли это с правилами компании?',
      'Имею ли я полномочия на это?',
      'Буду ли я чувствовать себя комфортно, если информация о моих действиях будет опубликована в СМИ?',
    ],
  },
  {
    type: 'paragraph',
    content:
      'Если ответ на любой из этих вопросов — «Нет», следует воздержаться от того, что вы собирались сделать.',
  },
  {
    type: 'paragraph',
    content:
      'Если у вас есть вопросы по темам, отраженным в Кодексе, имеются сомнения относительно того, регулируется ли ситуация Кодексом или является ли она его нарушением, нужно обсудить такую ситуацию со своим непосредственным или вышестоящим руководителем, или направить вопрос в адрес функции комплаенс.',
  },
]

export const business: BlockType[] = [
  {
    type: 'title',
    content: 'Комфортные рабочие условия',
  },
  {
    type: 'paragraph',
    content:
      'Компания стремится обеспечить уважительные, комфортные и безопасные условия труда для каждого сотрудника, придерживаясь при этом передовых методов обеспечения охраны труда и техники безопасности. В МТС Медиа делается все возможное для создания благоприятной рабочей среды, в которой каждый человек имеет возможность полностью раскрыть свой потенциал, не подвергаясь притеснению, предубеждениям и / или дискриминации любого рода. МТС Медиа пресекает недопустимое поведение как в отношении сотрудников и директоров, так и с их стороны.',
  },
  {
    type: 'title',
    content: 'Урегулирование конфликта интересов и иные практики',
  },
  {
    type: 'paragraph',
    content:
      'Для компании недопустимо, чтобы личные интересы сотрудника, оказывали фактическое влияние на их способность принимать справедливые и объективные решения в ходе работы на МТС Медиа, или чтобы создавалась видимость такого влияния. МТС Медиа обеспечивает сотрудников механизмами для предотвращения конфликтов интересов. Для любой ситуации конфликта интересов, если невозможно избежать участия в этом событии или деятельности, необходимо сообщать о нем и воздерживаться от участия в соответствующих решениях, пока конфликт не будет урегулирован. МТС Медиа разработала и поддерживает принципы ответственного дарения и получения подарков и знаков делового гостеприимства. МТС Медиа не допускает недобросовестного использования подарков, например, в целях получения неправомерного преимущества.',
  },
  {
    type: 'title',
    content: 'Защита материальной и интеллектуальной собственности',
  },
  {
    type: 'paragraph',
    content:
      'Сотрудники МТС Медиа обязаны защищать активы компании, включая материальную и интеллектуальную собственность, от краж, повреждений, неправомерного использования и ненадлежащей утилизации, в том числе третьими сторонами. Компания имеет четкие руководящие принципы, соответствующие требуемым процедурам безопасности, направленные на защиту секретной информации, конфиденциальных данных, а также на обеспечение осторожного и ответственного обращения с персональными данными, касающимися клиентов, сотрудников или других лиц. Компания защищает созданные нами объекты интеллектуальной собственности и уважает интеллектуальную собственность других.',
  },
  { type: 'title', content: 'Добросовестные коммерческие практики' },
  {
    type: 'paragraph',
    content:
      'МТС Медиа строит долгосрочные отношения с клиентами, за счет предоставления качественных и безопасных услуг и продуктов экосистемы МТС, и комфортных условиях обслуживания. Ни одно сообщение клиента не должно оставаться без ответа.',
  },
  {
    type: 'paragraph',
    content:
      'МТС Медиа использует добросовестные способы продвижения услуг, исключающие их восприятие как неэтичных либо способных причинить вред клиентам, партнерам или третьим лицам.',
  },
  {
    type: 'paragraph',
    content:
      'Мы не получаем конкурентных преимуществ за счет незаконных и неэтичных способов, в том числе, посредством сговоров и коррупционных практик.',
  },
]

export const law: BlockType[] = [
  { type: 'title', content: 'Противодействие коррупции и взяточничеству' },
  {
    type: 'paragraph',
    content:
      'Сотрудникам и лицам, действующим от имени или в интересах компании, МТС Медиа запрещает, как самостоятельно, так и через посредников, предлагать, обещать, осуществлять, одобрять, требовать или принимать любые незаконные платежи или выгоды от государственных и частных лиц. МТС Медиа не совершает платежи для упрощения формальностей и не участвует в политической деятельности, в том числе, не финансирует партии и кандидатов на политические посты. Чтобы помочь снизить любые потенциальные коррупционные риски, МТС Медиа устанавливает и поддерживает комплаенс контроли, направленные на предотвращение и выявление коррупции и взяточничества.',
  },
  { type: 'title', content: 'Обеспечение прозрачного раскрытия информации' },
  {
    type: 'paragraph',
    content:
      'Мы хотим, чтобы наши клиенты, сотрудники, партнеры, акционеры и инвесторы имели достаточную информацию о нашей деятельности. Мы стремимся быть открытыми и активными в наших коммуникациях. При раскрытии информации мы руководствуемся принципами соблюдения разумного баланса между информационной прозрачностью и обеспечением коммерческих интересов компании.',
  },
  { type: 'title', content: 'Использование инсайдерской информации' },
  {
    type: 'paragraph',
    content:
      'МТС Медиа не имеет публично обращающихся ценных бумаг и не является компанией, которой законодательство директивно предписывает внедрить меры по предотвращению, выявлению и пресечению неправомерного использования инсайдерской информации. Использование инсайдерской информации для получения личных выгод для сотрудника или третьих лиц нарушает требование законодательства и неприемлемо в МТС Медиа. Сотрудники и директора МТС Медиа не могут совершать сделки с ценными бумагами компаний, в отношении которых они обладают инсайдерской информацией, или передавать существенную непубличную информацию другим лицам без явного разрешения компании',
  },
]

const mail = 'external.hotline.mts@ru.ey.com'
const phoneHotline = getHotlinePhone()

export const messages: BlockType[] = [
  {
    type: 'paragraph',
    content:
      'МТС Медиа поддерживает культуру, в которой можно сообщать о проблемах, налаживая открытый и доверительный диалог с сотрудниками всех уровней. В рамках этого обязательства МТС Медиа поддерживает специальные процедуры для сотрудников и третьих лиц, по которой любое лицо может сообщить о предполагаемом или потенциальном нарушении требований законодательства, документов МТС Медиа или других проблемах, связанных с Кодексом.',
  },
  { type: 'paragraph', content: 'Вы можете выбрать удобный для вас:' },
  {
    type: 'list',
    content: [
      'обратитесь к прямому руководителю или, в случае если сообщение касается действий прямого руководителя, - к вышестоящему руководителю;',
      'обратитесь к комплаенс менеджеру (в любой форме);',
      'заполните электронную форму «Единой горячей линии» на официальном сайте МТС, корпоративном портале или через приложение «Наш МТС» (в том числе анонимно);',
      <>
        напишите на электронную почту «Единой горячей линии»:{' '}
        <a href={`mailto:${mail}`} className="link color nowrap">
          {mail}
        </a>
      </>,
      <>
        позвоните на независимую прямую линию{' '}
        <a href={`tel:${phoneHotline.href}`} className="link color nowrap">
          {phoneHotline.text}
        </a>
        .
      </>,
    ],
  },
  {
    type: 'paragraph',
    content:
      'При получении и рассмотрении обращений МТС гарантирует отправителям конфиденциальность и неразглашение персональных данных. Компания также обязуется не допускать ответных действий в отношении добросовестных лиц, сообщающих о предполагаемых нарушениях.',
  },
]
